import PhoneNoInput from "./PhoneNoInput";

export default PhoneNoInput
